import { useRef } from 'react';
import { LoanPhases, Phases } from '../LoanPhase.constanst';

// Components
import { PhaseModal } from './components/PhaseModal';
import { TabBarProgress } from './components/SharedComponents';

// Hook
import { useLoanPhases } from './useLoanPhases';

// Utils
import { useClickOutside } from '@common/utils/hooks/useClickOutside';

// Types
interface Props {
  loan: any;
  rulesTasksCards: any[];
  phaseSelect: string;
  handlerSetPhaseSelect: any;
  handlerSetTaskOpenModal: any;
  handlerSetProgressData: any;
}

const LoanProgress = ({
  loan,
  rulesTasksCards,
  handlerSetPhaseSelect,
  handlerSetTaskOpenModal,
  handlerSetProgressData
}: Props) => {
  const divOpen = useRef<HTMLDivElement>(null);
  
  const {
    phases,
    phaseSelect,
    setPhaseSelect,
    loanDocs
  } = useLoanPhases({
    loan,
    tasks: rulesTasksCards,
    handlerSetProgressData
  });

  useClickOutside(divOpen, () => setPhaseSelect(undefined));

  const onClickPhaseProgress = (phase: LoanPhases) => {
    if (phase.id === phaseSelect?.id)
      setPhaseSelect(undefined);
    else setPhaseSelect(phase);

    if (phase.key === Phases.APPROVAL || phase.key === Phases.DUE_DILIGENCE)
      handlerSetPhaseSelect(phase.key);
  };

  const handlerClickTask = (task: any) => {
    if (task.loanDoc?.file?.url && !task.loanDoc?.hidden) {
      window.open(`${task.loanDoc.file.url}?preview=true&app=processing`, '_blank');
      return;
    }
    handlerSetTaskOpenModal(task.key);
  };

  return (
    <section className="LoanProgress">
      {/* Main phase tabs */}
      {phases?.map((tab: any) => (
        <div
          className={`tab tab-${tab.state}`}
          key={tab.key}
          onClick={() => onClickPhaseProgress(tab)}
        >
          <TabBarProgress tab={tab} />
        </div>
      ))}

      {/* Expanded phase modal */}
      {phaseSelect && (
        <div className='tab-open-content' ref={divOpen}>
          <PhaseModal
            loan={loan}
            phaseSelect={phaseSelect}
            phases={phases}
            onClickPhaseProgress={onClickPhaseProgress}
            handlerClickTask={handlerClickTask}
          />
        </div>
      )}
    </section>
  );
};

export default LoanProgress;